/*
login-form-ctrl.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/modules/login-form/controllers/login-form-ctrl',['angular', 'ui-router', 'loginApi', 'geFormSubmitted', 'inputPatterns', '../services/login-form-i18n', 'alertBox',
    'redirectApi', 'sessionStorage', 'existingUserCheckApi', 'lodash', 'authenticationStoreService', 'redirectUsingPostService', 'sitesApi'
], function () {

    // Module Dependencies
    var dependencies = [
        'ui.router',
        'Services.LoginApi',
        'Services.InputPatterns',
        'Directives.GeFormSubmitted',
        'LoginForm.Services.i18n',
        'Directives.AlertBox',
        'Services.RedirectApi',
        'Services.SessionStorage',
        'Services.ExistingUserCheckApi',
        'Services.authenticationStoreService',
        'Services.redirectUsingPostService',
        'Services.SitesApi'
    ];

    // Module Definition
    var mod = angular.module('LoginForm.Controllers.LoginFormCtrl', dependencies);

    /**
     * @name LoginFormCtrl
     * @type controller
     *
     * @description
     * Controller for the 'Login' page's login form.
     */
    mod.controller('LoginFormCtrl', ['$scope', '$window', 'LoginForm.i18n', 'loginApi', 'sitesApi', 'inputPatterns', '$rootScope', 'redirectApi', 'sessionStorage', '$q', 'existingUserCheckApi', '$sce', 'authenticationStoreService', 'redirectUsingPostService',
        function ($scope, $window, i18n, loginApi, sitesApi, inputPatterns, $rootScope, redirectApi, sessionStorage, $q, existingUserCheckApi, $sce, authenticationStoreService, redirectUsingPostService) {

            $scope.isMessageTypeImage = false;
            $scope.logoPath = "";
            $scope.orgDisplayMessage = "";
            $scope.messagePath = "";

            $scope.orgLogoObj = $rootScope.orgLogoObj;

            if ($scope.orgLogoObj) {
                $scope.IMAGE_BASE_URL = "/getImage/" + $scope.orgLogoObj.uuid + "/";
                var IMAGE_BASE_URL = "/getImage/" + $scope.orgLogoObj.uuid + "/";
                $scope.logoPath = IMAGE_BASE_URL + $scope.orgLogoObj.logoPath;
                $scope.url = addhttp($scope.orgLogoObj.backgroundImagePath);
                if (($scope.orgLogoObj.messageType).toLowerCase() === "image") {
                    $scope.isMessageTypeImage = true;
                    $scope.messagePath = IMAGE_BASE_URL + $scope.orgLogoObj.messageImagePath;
                } else {
                    $scope.isMessageTypeImage = false;
                    $scope.orgDisplayMessage = $scope.orgLogoObj.messageText;

                    var urlRegex = /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/;
                    $scope.orgDisplayMessage = $scope.orgDisplayMessage.replace(urlRegex, function (url) {
                        if (url.search("www.") === 0) {
                            return '<a style="text-decoration: underline;" target="_blank" href="https://' + url + '">' + url + '</a>';
                        } else {
                            return '<a style="text-decoration: underline;" target="_blank" href="' + url + '">' + url + '</a>';
                        }
                    });
                    $scope.orgDisplayMessage = $sce.trustAsHtml($scope.orgDisplayMessage);
                }
            }

            //function for add https
            function addhttp(url) {
                if (!/^(f|ht)tps?:\/\//i.test(url)) {
                    url = "https://" + url;
                }
                return url;
            }

            // Collection of localized messages
            $scope.msg = i18n.getMessages();

            // Display Play's global info message (if any)
            $scope.infoMsg = $sce.trustAsHtml($window.playInfoMessage) || '';

            // Container for all form input data
            $scope.formData = {};

            // Pattern matching for input values
            $scope.inputPatterns = inputPatterns;

            // Flag that prevents multiple simultaneous login requests
            var isLoginRequestInProgress = false;

            //flag for cas-url from config file
            angular.element('body').data('url');

            //flag for validatorType from config file
            angular.element('body').data('validator_saml');

            //flag for isExternalAuthEnabled from config file
            angular.element('body').data('flag');

            var redirectToSSO = function (validatorType, validatorUrl, isExternalAuthEnabled) {
                var url = {'url': ''};
                if (isExternalAuthEnabled) {
                    if ($scope.healthcareProviderValue && $scope.isSSOEnable) {
                        url.url = "/";
                        sessionStorage.setStorageData('sessionUrl', url);
                        var data = {
                            'validator': validatorType,
                            'redirectUrl': validatorUrl,
                            'appUrl': '/logout',
                            'params': $scope.licenseNumber,
                            'isSSOEnable': $scope.isSSOEnable ? 'true' : 'false'
                        };
                        redirectApi.redirectToValidation(data).then(
                            function (response) {
                                if (response) {
                                    console.log("Successfully redirect validation");
                                }
                            }
                        );
                    } else {
                        localStorage.setItem('isOrgSelected', true);
                        sessionStorage.setStorageData('externalAuthVerified', true);
                        redirectUsingPostService.redirect('ib');
                    }
                } else {
                    localStorage.setItem('isOrgSelected', true);
                    sessionStorage.setStorageData('externalAuthVerified', true);
                    redirectUsingPostService.redirect('ib');
                }
            };

            var verifyForLicenseNumber = function (validatorType, validatorUrl, isExternalAuthEnabled) {
                var deferred = $q.defer();
                loginApi.getUserData(userName).then(
                    function (response) {
                        if (response === 202) {
                            $scope.healthcareProviderValue = true;
                            $scope.licenseNumber = '';
                            $scope.isSSOEnable = true;
                        }
                        redirectToSSO(validatorType, validatorUrl, isExternalAuthEnabled);
                        deferred.resolve(true);

                    },
                    function (response) {
                        // Display an error message
                        $scope.errorMsg = response;
                        deferred.resolve(false);
                    });
            };

            var setOrganization = function (orgId, validatorType, validatorUrl, isExternalAuthEnabled, isSSOMandatory) {
                sitesApi.setUserOrganization(orgId).then(function (response) {
                    if (response.data.statusCode === "200" || response.data.statusCode === "500") {
                        localStorage.setItem('isOrgSelected', true);
                        localStorage.setItem('selectedPortalOrgId', orgId);
                        if (isExternalAuthEnabled && isSSOMandatory) {
                            verifyForLicenseNumber(validatorType, validatorUrl, isExternalAuthEnabled);
                        } else {
                            sessionStorage.setStorageData('externalAuthVerified', true);
                            redirectUsingPostService.redirect('ib');
                        }
                    } else {
                        $window.location.href = "/logout";
                    }
                });
            };

            var $body = angular.element('body');

            function checkOrgAccess() {
                $scope.isSSOEnable = false;

                sessionStorage.setStorageData('externalAuthVerified', false);
                localStorage.setItem('isOrgSelected', false);
                sessionStorage.setStorageData('hideUploadModal', false);
                sessionStorage.setStorageData('hideDownloadModal', false);

                // Retrieves the current logged in user
                sessionStorage.getStorageData('userName');

                //flag for validatorType from config file
                var validatorType = $body.data('validator_saml');

                //flag for cas-url from config file
                var validatorUrl = $body.data('url');

                //flag for isExternalAuthEnabled from config file
                var isExternalAuthEnabled = $body.data('flag');

                sitesApi.getUserOrganization().then(
                    function (response) {
                        if (response && response.responseText === 'Unauthorized') {
                            var message = "401";
                            window.location = '/login?message=' + message;
                        } else if (!response.count) {
                            $window.location.href = "/login";
                        } else if (response === "" || response.count === 0 || response.statusCode === "500" || response.statusCode === "401") {
                            $window.location.href = "/logout";
                        } else if (response.count === 1) {
                            userOrganizationCountIsOne(response);
                        } else if (response.count > 1) {
                            redirectUsingPostService.redirect('do');
                        }
                    }, function (response) {
                        if (response && response === 'Unauthorized') {
                            var message = "401";
                            window.location = '/login?message=' + message;
                        }
                    });

                function userOrganizationCountIsOne(response) {
                    if (response.result[0].hasPortalAccess) {
                        setOrganization(response.result[0].id, validatorType, validatorUrl, isExternalAuthEnabled, response.result[0].isSSOMandatory);
                    } else {
                        localStorage.setItem('isOrgSelected', true);
                        if (isExternalAuthEnabled && response.result[0].isSSOMandatory) {
                            verifyForLicenseNumber(validatorType, validatorUrl, isExternalAuthEnabled);
                        } else {
                            sessionStorage.setStorageData('externalAuthVerified', true);
                            redirectUsingPostService.redirect('ib');
                        }
                    }
                };
            }

            /**
             * Executes a login process after the external authentication for healthcare provider
             * and without external authentication for patient
             */
            var loginProcess = function () {
                var data = {
                    username: $scope.formData.username,
                    password: $scope.formData.password,
                    rememberme: false,
                    isHealthcareProviderValue: $scope.healthcareProviderValue,
                    targetUrl: '',
                    isSSOEnable: $scope.isSSOEnable ? 'true' : 'false',
                    appUrl: '/logout',
                    client_name: 'formClient'
                };

                sessionStorage.setStorageData('userName', $scope.formData.username);

                // Send request
                loginApi.loginUser(data)
                    .then(function (response) {
                        if (response) {
                            var value = JSON.parse(response);
                            console.log("Responsce from" + value);

                            if (value && value.transitioningToSSO) {
                                $scope.$emit('displayMessage', {
                                    type: 'transitioningToSSO',
                                    orgSSOIdentifier: value.orgSSOIdentifier,
                                    orgLegalName: value.orgLegalName
                                });
                                return;
                            }

                            if (value && value.cIdToken) {
                                authenticationStoreService.setAuthDataOnLogin(value);
                                authenticationStoreService.setLoggedInUserName($scope.formData.username);
                            }

                            loginApi.isSecondFactAuthEnabled($scope.formData.username).then(
                                function (response) {
                                    if (response && response.statusCode === 200) {
                                        redirectUsingPostService.redirect('sfa');
                                        if (response.flag === true) {
                                            localStorage.setItem("smsTwoFactFlag", 1001);
                                        } else {
                                            localStorage.setItem("smsTwoFactFlag", -999);
                                        }
                                    } else if (response && response.statusCode === 202) {
                                        checkOrgAccess();
                                    } else if (response && response.statusCode === 401) {
                                        $scope.errorMsg = $sce.trustAsHtml($scope.msg.invalidUsernamePassword);
                                    }

                                }, function (response) {
                                    // Display an error message
                                    $scope.errorMsg = $sce.trustAsHtml(response);
                                }
                            );
                        }

                    }, function (response) {
                        // Display an error message
                        $scope.errorMsg = $sce.trustAsHtml(response);
                    })
                    .finally(function() {
                        // Unset flag
                        isLoginRequestInProgress = false;
                    });
            };

            /**
             * Sends a login request with the credentials that have been provided by the user.
             */
            $scope.submit = function () {
                $scope.isSSOEnable = false;
                // Prevent invalid and redundant requests
                if ($scope.loginForm.$valid === true && isLoginRequestInProgress === false) {
                    // Set flag
                    isLoginRequestInProgress = true;
                    // Prepare data

                    $scope.healthcareProviderValue = false;

                    loginProcess();
                }
            };

        }]);

});

